<template>
  <div>
    <v-layout row wrap class="mb-4">
      <v-btn round color="primary" @click.prevent="doBack">
        <v-icon left dark>mdi-chevron-left</v-icon>
        Back
      </v-btn>
    </v-layout>
    <v-alert type="error" :value="true" v-if="quotePermitStatus.permitStatus === 'D'">
      Quotation Declined
      <ul class="permitStatus">
        <li v-for="status in quotePermitStatus.declineList" :key="status">{{status}}</li>
      </ul>
    </v-alert>
    <v-alert type="warning" :value="true" v-else-if="quotePermitStatus.permitStatus === 'R'">
      Quotation Referred
      <ul class="permitStatus">
        <li v-for="status in quotePermitStatus.referredList" :key="status">{{status}}</li>
      </ul>
    </v-alert>
    <message :messages="messages"></message>
    <premium-shared></premium-shared>
    <v-layout row wrap class="pt-3">
      <v-btn round color="primary" @click.prevent="doBack">
        <v-icon left dark>mdi-chevron-left</v-icon>
        Back
      </v-btn>
      <v-spacer></v-spacer>

      <v-btn color="error" :loading="quotation.saving" @click.prevent="doDecline" :disabled="premiumInfo.init !== 1">
        Decline
        <v-icon right dark>mdi-close</v-icon>
      </v-btn>
      <v-btn color="primary" :loading="quotation.saving" @click.prevent="doApprove" :disabled="premiumInfo.init !== 1">
        Approve
        <v-icon right dark>mdi-check</v-icon>
      </v-btn>
    </v-layout>
  </div>
</template>

<script>
import { AGENCY_QUOTATION_LIFECYCLE, AGENCY_QUOTATION_SAVE_LOADING, AGENCY_QUOTATION_SAVE_SUCCESS, AGENCY_QUOTATION_SAVE_FAIL, AGENCY_QUOTATION_LEAVEQUOTE } from '@/store/types'
import MessageMixin from '@/mixins/message'
import { SaveQuoteMixin } from '../../shared/saveQuoteMixin'
import PremiumShared from '../quotation/sub/PremiumShared'
import { generalMotorForm } from '@/store/modules/agency/actions/quote'

export default {
  computed: {
    quotePermitStatus() {
      return this.$store.getters.mtrQuoteQueryPermitStatus
    },
    quotation() {
      return this.$store.state.agency.quotation
    },
    premiumInfo() {
      return this.quotation.commonInfo.premium
    }
  },
  methods: {
    doBack() {
      this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 2)
      this.$router.push({ name: 'motorQuoteRefStats' })
    },
    async doApprove() {
      const apiUrl = this.quotation.menu.approveRefQuote
      if (apiUrl) {
        try {
          this.$store.commit(AGENCY_QUOTATION_SAVE_LOADING)
          const result = await this.$http.post(apiUrl, generalMotorForm(this.$store.state.agency))
          this.$store.commit(AGENCY_QUOTATION_SAVE_SUCCESS)
          this.$snotify.success('Quotation has been approved')
          // After success push to listing page
          this.$store.commit(AGENCY_QUOTATION_LEAVEQUOTE)
          this.$router.push({ name: 'motorQuoteQuery', params: { id: result.data.proposalNo } })
        } catch (err) {
          if (err.response && err.response.data) {
            this.fullMessage(err.response.data)
          }
          // We need this to stop the loading (err msg will be displayed directly)
          this.$store.commit(AGENCY_QUOTATION_SAVE_FAIL, {})
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    async doDecline() {
      const apiUrl = this.quotation.menu.declineRefQuote
      if (apiUrl) {
        try {
          this.$store.commit(AGENCY_QUOTATION_SAVE_LOADING)
          const result = await this.$http.post(apiUrl, generalMotorForm(this.$store.state.agency))
          this.$store.commit(AGENCY_QUOTATION_SAVE_SUCCESS)
          this.$snotify.success('Quotation has been declined')
          // After success push to listing page
          this.$store.commit(AGENCY_QUOTATION_LEAVEQUOTE)
          this.$router.push({ name: 'motorQuoteQuery', params: { id: result.data.proposalNo } })
        } catch (err) {
          if (err.response && err.response.data) {
            this.fullMessage(err.response.data)
          }
          // We need this to stop the loading (err msg will be displayed directly)
          this.$store.commit(AGENCY_QUOTATION_SAVE_FAIL, {})
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    async doPartialSave() {
      try {
        await this.$store.dispatch('saveQuote')
        return true
      } catch (err) {
        return false
      }
    }
  },
  beforeMount() {
    // Check quote lifecycle (might be using back link or url)
    if (this.$store.state.agency.quotation.quoteLifeCycle !== 3) {
      this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 3)
    }
  },
  mixins: [
    MessageMixin,
    SaveQuoteMixin
  ],
  components: {
    PremiumShared
  }
}
</script>

<style>
</style>
